/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaHorizDivider/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaHorizDivider({
  children,
  viewPath = "/DesignSystem/TysiaHorizDivider",
  marginTop,
  marginBottom,
  marginLeft,
  marginRight,
  backgroundColor,
  width = "100%",
  theme
  
}) {
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let dtTysiahorizdividerBackgroundcolorDarkBase = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaHorizDivider.backgroundColor.dark.base'
        })
let dtTysiahorizdividerBackgroundcolorPrimaryBase = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaHorizDivider.backgroundColor.primary.base'
        })
let backgroundColorOrdtTysiahorizdividerBackgroundcolorDarkBase = backgroundColor ?? dtTysiahorizdividerBackgroundcolorDarkBase
let marginTopOrdtSpaceLs = marginTop ?? dtSpaceLs
let marginBottomOrdtSpaceLs = marginBottom ?? dtSpaceLs
  return (<React.Fragment
>
<div
  data-testid="TysiaHorizDivider.Horizontal"
  data-view-path={viewPath}
 style={{'--mt-1-kH479': typeof marginTopOrdtSpaceLs === 'number' ? `${marginTopOrdtSpaceLs}px` : marginTopOrdtSpaceLs,'--mb-2-kH479': typeof marginBottomOrdtSpaceLs === 'number' ? `${marginBottomOrdtSpaceLs}px` : marginBottomOrdtSpaceLs,'--ml-3-kH479': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-4-kH479': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--w-6-kH479': typeof width === 'number' ? `${width}px` : width,'--bc-5-kH479': theme === "light" ? dtTysiahorizdividerBackgroundcolorPrimaryBase : theme === "dark" ? dtTysiahorizdividerBackgroundcolorDarkBase : backgroundColorOrdtTysiahorizdividerBackgroundcolorDarkBase}}
 className={`views-block ${styles.Horizontal}`}
/>
{children}
</React.Fragment>)
}